import type React from 'react';

export interface ModeBadgeProps {
  mode: 'h_a' | 'h_b' | 'h_c';
  compact?: boolean;
}

export function ModeBadge({ mode, compact }: ModeBadgeProps): React.JSX.Element | null {
  const map: Record<'h_a' | 'h_b' | 'h_c', { label: string; short: string; tone: string }> = {
    h_a: { label: 'Você dirige', short: 'Você', tone: 'success' },
    h_b: { label: 'Você + IA', short: 'Você+IA', tone: 'neutral' },
    // A-18 (noturna 04/Set/2026): o modo compacto mostrava o código interno «H_c» ao supervisor.
    h_c: { label: 'IA dirige', short: 'IA', tone: 'ai' },
  };
  const m = map[mode];
  if (m === undefined) return null;
  return <span className={`badge badge--${m.tone}`}>{compact === true ? m.short : m.label}</span>;
}
